<template>
  <v-flex :[dinamicFlexSmall]="true" :[dinamicFlexMedium]="true">
    <v-menu
      ref="menu_fecha"
      v-model="menu_fecha"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="fecha"
          :label="label"
          prepend-icon="fa-calendar"
          readonly
          v-on="on"
        />
      </template>
      <v-date-picker
        v-if="birthdayPicker"
        ref="picker"
        v-model="fecha"
        locale="es-mx"
        @input="menu_fecha = false"
        no-title
        :max="new Date().toISOString().substr(0, 10)"
      />
      <v-date-picker
        v-else
        ref="picker"
        v-model="fecha"
        locale="es-mx"
        @input="menu_fecha = false"
        no-title
      />
    </v-menu>
  </v-flex>
</template>

<script>
export default {
  name: 'fecha_picker',
  props: {
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: null,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: '3',
    },
    birthdayPicker: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      menu_fecha: false,
      fecha: this.value,
    };
  },
  computed: {
    dinamicFlexSmall() {
      return 'sm'.concat(this.size);
    },
    dinamicFlexMedium() {
      return 'md'.concat(this.size);
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    value(val) {
      this.fecha = this.value;
    },
    fecha: {
      inmediate: true,
      handler() {
        this.$emit('input', this.fecha);
      },
    },
    menu_fecha(value) {
      if (this.birthdayPicker) {
        // eslint-disable-next-line no-unused-expressions,no-return-assign
        value && this.$nextTick(() => this.$refs.picker.activePicker = 'YEAR');
      }
    },
  },
};
</script>

<style scoped>

</style>
